import React from "react";
import "../../Views/Home/styles/aboutHome-styles.css";

const AboutHome = () => {
  return (
    <>
      <div className="bg-black container-fluid justify-content-center">
        <div className="container-phrase">
          <p className="text-info text-center">
            "La meta no es el final, es solo el comienzo de un nuevo desafío."
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutHome;
